import './App.css';
import { Suspense, lazy, useEffect, useState } from 'react';
import NavBar from './components/NavBar/NavBar';
import FirstScreen from './screens/FirstScreen';
import useSeo from './seo/useSeo';
import { HOME_SEO } from './seo/siteMeta';

/* רק הניווט והמסך הראשון נטענים עם ה-bundle הראשי.
   כל השאר מפוצל ל-chunks נפרדים, כדי שהמסך הראשון יצויר
   בלי להמתין ל-MUI, ל-slick ול-lottie שמשמשים רק מתחת לקיפול. */
const SecondScreen = lazy(() => import('./screens/SecondScreen'));
const FormScreen = lazy(() => import('./screens/FormScreen'));
const ThirdScreen = lazy(() => import('./screens/ThirdScreen'));
const Clients = lazy(() => import('./components/Slider/Clients'));
const ForthScreen = lazy(() => import('./screens/ForthScreen'));
const BasicAccordion = lazy(() => import('./components/questions/Akordion'));
const PrivacyPolicy = lazy(() => import('./components/privacy/Privacy'));
const ByMe = lazy(() => import('./components/ByMe/ByMe'));

function App() {
  const [scrolled, setScrolled] = useState(false);

  useSeo(HOME_SEO);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.pageYOffset > 0);

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="wrap">
      <NavBar />
      <FirstScreen scrolled={scrolled} />

      <Suspense fallback={null}>
        <SecondScreen />
        <FormScreen title="הגיע הזמן לעשות את הצעד !" />
        <ThirdScreen />
        <Clients />
        <ForthScreen />
        <BasicAccordion />
        <FormScreen title="אם הגעת עד לכאן אז את רצינית לגבי התחום" />
        <PrivacyPolicy
          ownerName="ניקול ולארי"
          email="nikolmelayev20@gmail.com"
          phone="+972537133055"
          domain="https://nikolvalerie.co.il"
        />
        <ByMe />
      </Suspense>
    </div>
  );
}

export default App;
